import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=c9324d20&scoped=true&"
import script from "./Initial.vue?vue&type=script&lang=js&"
export * from "./Initial.vue?vue&type=script&lang=js&"
import style0 from "./Initial.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Initial.vue?vue&type=style&index=1&id=c9324d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9324d20",
  null
  
)

export default component.exports